'use strict';

const kdContextError = require('./kd-context');

/**
 * DB Error
 *
 * This error denotes a Database Error, usually thrown when an error
 * occurs relative to the persistence layer or general database usage.
 *
 * @param {string} message - Error message
 * @param {Object} detail - Error detail message
 * @param {Object} context - Database context data
 */
class DBError extends kdContextError {
    constructor(message, detail, context) {
        super(message, detail, context);
        this.name = 'DBError';
        this.status = 500;
    }
}

module.exports = DBError;



/** WEBPACK FOOTER **
 ** ./src/common/error/db.js
 **/